import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["dispatch", "listen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { SandpackReactContext } from "../contexts/sandpackContext";
export function useSandpack() {
  var sandpack = React.useContext(SandpackReactContext);

  if (sandpack === null) {
    throw new Error("useSandpack can only be used inside components wrapped by 'SandpackProvider'");
  }

  var dispatch = sandpack.dispatch,
      listen = sandpack.listen,
      rest = _objectWithoutProperties(sandpack, _excluded);

  return {
    sandpack: _objectSpread({}, rest),
    dispatch: dispatch,
    listen: listen
  };
}